import {post} from './httpBase';

//待分流订单列表
export function shuntorderlist(params) {
    return post('/order/manageshuntorder/shuntorderlist', params)
}
//派单调度列表
export function dispatchOrderlist(params) {
    return post('/order/shuntorder/orderpool', params)
}
// 发单预览
// export function sendOrderPreview(params) {
//     return post('/order/manageshuntorder/shuntorderlistpreview', params)
// }
//订单预览
export function orderPreview(params) {
    return post('/order/manageshuntorder/getdetailsbyshuntorderconid', params)
}
//司机列表
export function driverList(params) {
    return post('/order/manageshuntorder/matchingdriverbyconbid', params)
}
//关闭订单
export function closeOrder(params) {
    return post('/order/shuntorder/assembleorderclose', params)
}
//确认发单
export function confirmOrder(params) {
    return post('/order/shuntorder/assembleorder', params)
}
//发单预览
export function getBillView(params) {
    return post('/order/manageshuntorder/shuntorderlistpreview', params)
}
//选择司机派单
export function selectDrvier(params) {
    return post('/order/manageshuntorder/dispatchsubmit', params)
}
//分流下单，调度人员获取起止点名称和经纬度
export function getSation(params) {
    return post('/order/manageshuntorder/dispatchergetsationmessage', params)
}
//调度人员下单时判断是否在接送范围内
export function checkDistance(params) {
    return post('/order/manageshuntorder/cheakdistance', params)
}
//根据起始地址经纬度获取理论价格
export function getDistancePrice(params) {
    return post('/order/manageshuntorder/distanceoftwinsaddress', params)
}
//调度人员下分流订单
export function commitOrder(params) {
    return post('/order/manageshuntorder/distanceofshuntorder', params)
}
//调度人员分流订单修改
export function commitEditOrder(params) {
    return post('/order/manageshuntorder/changeshuntorderaddress', params)
}
//调度人员订单组合时直接给司机派单
export function resendorder(params) {
    return post('/order/manageshuntorder/resendorder', params)
}


// WEBPACK FOOTER //
// ./src/service/shuntService.js